var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"preference-list"},_vm._l((_vm.statuses),function(x){return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.preferences[x.status]),expression:"preferences[x.status]"}],key:x.status,staticClass:"preference-item",attrs:{"span":12}},[_c('i',{staticClass:"mat-icon"},[_vm._v("chevron_right")]),_vm._v(" "+_vm._s(x.name))])}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a24dc270","hasScoped":true,"buble":{"transforms":{}}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/staff/blocks/PreferencesSummary.vue
// module id = 703
// module chunks = 0